import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import BackLink from '../../HelperComponents/BackLink/BackLink';
import ControlPanel from '../../HelperComponents/ControlPanel/ControlPanel';
import Loader from '../../HelperComponents/Loader/Loader';
import Pagination from '../../HelperComponents/Pagination/Pagination';
import RenderField from '../../HelperComponents/RenderField/RenderField';
import SelectComponent from '../../HelperComponents/SelectComponent/SelectComponent';
import SnackBar from '../../HelperComponents/SnackBar/SnackBar';
import StatusDot from '../../HelperComponents/StatusDot/StatusDot';
import TransitionedBlock from '../../HelperComponents/TransitionedBlock/TransitionedBlock';
import DefaultButton from '../../Buttons/DefaultButton/DefaultButton';
import ReturnDispatchPrintButton from '../ReturnDispatchPrintButton/ReturnDispatchPrintButton';
import ReturnDispatchOfferToStockDialog from '../ReturnDispatchOfferToStockDialog/ReturnDispatchOfferToStockDialog';

import {
    approveReturnDispatch,
    getReturnDispatches,
    getReturnDispatchesDailySummary,
    getReturnDispatchSupplierProducts,
    offerReturnDispatchProductToStock,
} from '../../../actions/returnDispatchesActions';
import { formatPrice, getPositionStatusColor } from '../../../helpers/functions';

import SearchIcon from '../../../assets/image/search_grey.png';

import './ReturnDispatchSupplier.scss';

const today = new Date().toISOString().split('T')[0];

const DISPATCH_STATUSES = [
    { label: 'Не обработана', value: 'pending' },
    { label: 'Частично обработана', value: 'partial' },
    { label: 'Обработана', value: 'completed' },
];

const PRODUCT_STATUSES = [
    { label: 'На рассмотрении', value: 'pending' },
    { label: 'Одобрена на склад', value: 'approved_to_stock' },
    { label: 'Одобрена', value: 'approved' },
    { label: 'Отказ', value: 'denied' },
];

const getDispatchStatusColor = (status) => {
    switch (status) {
        case 'Обработана': return 'green';
        case 'Частично обработана': return 'orange';
        default: return 'grey';
    }
};

const isPendingProduct = (product) => (
    product.item_status === 'На рассмотрении'
    || product.item_status === 'На рассмотрение'
    || product.item_status === 'Ожидает обработки'
);

class ReturnDispatchSupplier extends Component {
    state = {
        activeTab: 'dispatches',
        dispatchPage: 1,
        dispatchPageSize: 10,
        dispatchQuery: '',
        dispatchStatus: null,
        productPage: 1,
        productPageSize: 10,
        productQuery: '',
        productStatus: null,
        selectedProductIds: [],
        supplierName: this.props.location.state && this.props.location.state.supplierName,
        summaryDate: today,
        summaryLoading: true,
        dispatchesLoading: true,
        dispatchesLoaded: false,
        productsLoading: false,
        productsLoaded: false,
        actionLoading: false,
        actionType: null,
        stockDialogProduct: null,
        notification: {
            open: false,
            type: 'success',
            message: '',
        },
    };

    componentDidMount = () => {
        this.setState(this.parseQueryToState(), () => {
            if (this.state.activeTab === 'products') {
                this.loadProducts();
            } else {
                this.loadDispatches();
            }
            this.fetchDailySummary();
        });
    };

    get supplierId() {
        return this.props.match.params.supplierId;
    }

    parseQueryToState = () => {
        const params = new URLSearchParams(this.props.location.search);
        const activeTab = params.get('tab') === 'products' ? 'products' : 'dispatches';
        const isProducts = activeTab === 'products';
        const nextState = { activeTab };
        const page = Number(params.get('page')) || 1;
        const pageSize = Number(params.get('page_size')) || 10;
        const query = params.get('query') || '';
        const statusValue = params.get('status');
        const statuses = isProducts ? PRODUCT_STATUSES : DISPATCH_STATUSES;
        const status = statusValue
            ? statuses.find((item) => item.value === statusValue) || null
            : null;
        const summaryDate = params.get('summary_date');

        if (isProducts) {
            nextState.productPage = page;
            nextState.productPageSize = pageSize;
            nextState.productQuery = query;
            nextState.productStatus = status;
        } else {
            nextState.dispatchPage = page;
            nextState.dispatchPageSize = pageSize;
            nextState.dispatchQuery = query;
            nextState.dispatchStatus = status;
        }
        if (summaryDate) nextState.summaryDate = summaryDate;

        return nextState;
    };

    syncStateToQuery = () => {
        const {
            activeTab,
            dispatchPage,
            dispatchPageSize,
            dispatchQuery,
            dispatchStatus,
            productPage,
            productPageSize,
            productQuery,
            productStatus,
            summaryDate,
        } = this.state;
        const isProducts = activeTab === 'products';
        const page = isProducts ? productPage : dispatchPage;
        const pageSize = isProducts ? productPageSize : dispatchPageSize;
        const query = isProducts ? productQuery : dispatchQuery;
        const status = isProducts ? productStatus : dispatchStatus;
        const params = new URLSearchParams();

        params.set('tab', activeTab);
        if (page !== 1) params.set('page', String(page));
        if (pageSize !== 10) params.set('page_size', String(pageSize));
        if (query) params.set('query', query);
        if (status && status.value) params.set('status', status.value);
        if (summaryDate !== today) params.set('summary_date', summaryDate);

        const search = `?${params.toString()}`;
        if (this.props.location.search !== search) {
            this.props.history.replace({
                ...this.props.location,
                search,
            });
        }
    };

    buildParams = (page, pageSize, query, status) => {
        const params = {
            page,
            page_size: pageSize,
        };

        if (query) params.query = query;
        if (status && status.value) params.status = status.value;

        return params;
    };

    loadDispatches = () => {
        const {
            dispatchPage,
            dispatchPageSize,
            dispatchQuery,
            dispatchStatus,
        } = this.state;
        const params = this.buildParams(
            dispatchPage,
            dispatchPageSize,
            dispatchQuery,
            dispatchStatus,
        );
        params.supplier_id = this.supplierId;

        this.syncStateToQuery();
        this.setState({ dispatchesLoading: true });
        this.props.getReturnDispatches(params).then((res) => {
            const results = res && res.payload && res.payload.data && res.payload.data.results;
            const supplierName = results && results.length ? results[0].supplier : null;

            this.setState((state) => ({
                dispatchesLoading: false,
                dispatchesLoaded: true,
                supplierName: state.supplierName || supplierName,
            }));
        });
    };

    loadProducts = () => {
        const {
            productPage,
            productPageSize,
            productQuery,
            productStatus,
        } = this.state;
        const params = this.buildParams(
            productPage,
            productPageSize,
            productQuery,
            productStatus,
        );

        this.syncStateToQuery();
        this.setState({ productsLoading: true, selectedProductIds: [] });
        this.props.getReturnDispatchSupplierProducts(this.supplierId, params).then(() => {
            this.setState({ productsLoading: false, productsLoaded: true });
        });
    };

    fetchDailySummary = () => {
        this.setState({ summaryLoading: true });
        this.props.getReturnDispatchesDailySummary({
            supplier_id: this.supplierId,
            date: this.state.summaryDate,
        }).then(() => {
            this.setState({ summaryLoading: false });
        });
    };

    changeTab = (activeTab) => {
        this.setState({ activeTab }, () => {
            this.syncStateToQuery();
            if (activeTab === 'products' && !this.state.productsLoaded) {
                this.loadProducts();
            } else if (activeTab === 'dispatches' && !this.state.dispatchesLoaded) {
                this.loadDispatches();
            }
        });
    };

    changeDate = (event) => {
        this.setState({ summaryDate: event.target.value }, () => {
            this.syncStateToQuery();
            this.fetchDailySummary();
        });
    };

    changeFilter = (name, value, request) => {
        const pageName = request === 'dispatches' ? 'dispatchPage' : 'productPage';
        this.setState({ [name]: value, [pageName]: 1 }, () => {
            request === 'dispatches' ? this.loadDispatches() : this.loadProducts();
        });
    };

    changePage = (request, page) => {
        const pageName = request === 'dispatches' ? 'dispatchPage' : 'productPage';
        this.setState({ [pageName]: page.selected + 1 }, () => {
            request === 'dispatches' ? this.loadDispatches() : this.loadProducts();
        });
    };

    changePageSize = (request, pageSize) => {
        const sizeName = request === 'dispatches' ? 'dispatchPageSize' : 'productPageSize';
        const pageName = request === 'dispatches' ? 'dispatchPage' : 'productPage';
        this.setState({ [sizeName]: Number(pageSize), [pageName]: 1 }, () => {
            request === 'dispatches' ? this.loadDispatches() : this.loadProducts();
        });
    };

    handleSearchKey = (request, event) => {
        if (event.keyCode !== 13) return;

        const pageName = request === 'dispatches' ? 'dispatchPage' : 'productPage';
        this.setState({ [pageName]: 1 }, () => {
            request === 'dispatches' ? this.loadDispatches() : this.loadProducts();
        });
    };

    handleSearchClick = (request) => {
        const pageName = request === 'dispatches' ? 'dispatchPage' : 'productPage';
        this.setState({ [pageName]: 1 }, () => {
            request === 'dispatches' ? this.loadDispatches() : this.loadProducts();
        });
    };

    toggleProduct = (productId) => {
        this.setState(({ selectedProductIds }) => ({
            selectedProductIds: selectedProductIds.includes(productId)
                ? selectedProductIds.filter((id) => id !== productId)
                : [...selectedProductIds, productId],
        }));
    };

    getSelectedProducts = () => {
        const { return_dispatch_supplier_products } = this.props.return_dispatches;
        const results = return_dispatch_supplier_products.results || [];
        return results.filter((product) => this.state.selectedProductIds.includes(product.id));
    };

    getSelectedSum = () => this.getSelectedProducts()
        .reduce((sum, product) => sum + (Number(product.total_sum) || 0), 0);

    getActionError = (response, fallback) => {
        const errorData = response
            && response.error
            && response.error.response
            && response.error.response.data;
        const error = errorData && (errorData.error || errorData.detail);

        if (Array.isArray(error)) return error.join(', ');
        return error || fallback;
    };

    finishProductAction = (response, successMessage) => {
        const status = response && response.payload && response.payload.status;
        const success = status >= 200 && status < 300;
        const message = success
            ? successMessage
            : this.getActionError(response, 'Не удалось обработать товары. Список обновлён.');

        this.setState({
            actionLoading: false,
            actionType: null,
            stockDialogProduct: null,
            notification: {
                open: true,
                type: success ? 'success' : 'error',
                message,
            },
        }, () => {
            this.loadProducts();
            this.fetchDailySummary();
        });
    };

    handleApprove = () => {
        const selectedProducts = this.getSelectedProducts();
        if (!selectedProducts.length) return;

        this.setState({ actionLoading: true, actionType: 'approve' });
        this.props.approveReturnDispatch({
            items: selectedProducts.map((product) => ({
                dispatch_product_id: product.id,
            })),
            supplier_id: Number(this.supplierId),
        }).then((response) => {
            this.finishProductAction(response, 'Выбранные товары одобрены');
        });
    };

    openStockDialog = () => {
        const selectedProducts = this.getSelectedProducts();
        if (selectedProducts.length !== 1) return;

        this.setState({ stockDialogProduct: selectedProducts[0] });
    };

    handleApproveToStock = (data) => {
        this.setState({ actionLoading: true, actionType: 'stock' });
        this.props.offerReturnDispatchProductToStock(data).then((response) => {
            this.finishProductAction(response, 'Товар одобрен на склад');
        });
    };

    renderSummary = () => {
        const { daily_summary } = this.props.return_dispatches;
        const { summaryLoading, summaryDate } = this.state;

        return (
            <div className="supplier_dispatch_summary">
                <div className="daily_summary_block">
                    <span className="green_text">
                        {!summaryLoading && daily_summary.approved_total_sum !== undefined
                            ? formatPrice(daily_summary.approved_total_sum)
                            : '—'}
                    </span>
                    {' / '}
                    <span className="red_text">
                        {!summaryLoading && daily_summary.dispatch_total_sum !== undefined
                            ? formatPrice(daily_summary.dispatch_total_sum)
                            : '—'}
                    </span>
                </div>
                <div className="summary_date_picker">
                    <RenderField
                        id="supplier_summary_date"
                        type="date"
                        name="supplier_summary_date"
                        placement="start"
                        meta={{}}
                        input={{
                            value: summaryDate,
                            onChange: this.changeDate,
                            size: 'small',
                        }}
                    />
                </div>
            </div>
        );
    };

    renderFilters = (request) => {
        const isDispatches = request === 'dispatches';
        const query = isDispatches ? this.state.dispatchQuery : this.state.productQuery;
        const status = isDispatches ? this.state.dispatchStatus : this.state.productStatus;
        const queryName = isDispatches ? 'dispatchQuery' : 'productQuery';
        const statusName = isDispatches ? 'dispatchStatus' : 'productStatus';

        return (
            <div className="supplier_dispatch_filters">
                <div className="supplier_dispatch_filters_left">
                    <div className="search_wrapper supplier_dispatch_search">
                        <div className="search_product_wrapper">
                            <input
                                type="text"
                                value={query}
                                onKeyDown={(event) => this.handleSearchKey(request, event)}
                                onChange={(event) => this.setState({ [queryName]: event.target.value })}
                                placeholder="Номер артикула/заказа"
                                autoComplete="off"
                            />
                        </div>
                        <div className="search_input_icon">
                            <img
                                src={SearchIcon}
                                alt="Поиск"
                                onClick={() => this.handleSearchClick(request)}
                            />
                        </div>
                    </div>
                    <FormControl className="supplier_dispatch_status">
                        <SelectComponent
                            value={status}
                            options={isDispatches ? DISPATCH_STATUSES : PRODUCT_STATUSES}
                            change={(value) => this.changeFilter(statusName, value, request)}
                            placeholder="Статус"
                            isSearchable={false}
                        />
                    </FormControl>
                </div>
                {this.renderSummary()}
            </div>
        );
    };

    renderDispatches = () => {
        const { all_return_dispatches } = this.props.return_dispatches;
        const { dispatchPage, dispatchPageSize, dispatchesLoading } = this.state;
        const results = all_return_dispatches.results || [];

        return (
            <div className="supplier_dispatch_tab_content">
                {this.renderFilters('dispatches')}
                {dispatchesLoading ? <Loader /> : (
                    <div className="supplier_dispatch_table supplier_dispatches_table">
                        <div className="table_container transactions_columns">
                            <div className="table_header">
                                <div className="table_row">
                                    <div className="row_item">Дата/время</div>
                                    <div className="row_item">Компания</div>
                                    <div className="row_item">Статус</div>
                                    <div className="row_item">Количество</div>
                                    <div className="row_item">Сумма</div>
                                    <div className="row_item">Печать</div>
                                </div>
                            </div>
                            <div className="table_body">
                                {results.length ? results.map((dispatch) => (
                                    <div
                                        className="table_row table_row_clickable"
                                        key={dispatch.id}
                                        onClick={() => this.props.history.push(`/admin/return-dispatch/${dispatch.id}`)}
                                    >
                                        <div className="row_item">{moment(dispatch.date).format('DD.MM.YYYY HH:mm')}</div>
                                        <div className="row_item">{dispatch.supplier}</div>
                                        <div className="row_item status_cell">
                                            <StatusDot color={getDispatchStatusColor(dispatch.status)} />
                                            {dispatch.status}
                                        </div>
                                        <div className="row_item">{dispatch.total_amount}</div>
                                        <div className="row_item">{formatPrice(dispatch.total_sum)}</div>
                                        <div className="row_item" onClick={(event) => event.stopPropagation()}>
                                            <ReturnDispatchPrintButton dispatch={dispatch} />
                                        </div>
                                    </div>
                                )) : <h1 className="empty_table_message">Выдач не найдено</h1>}
                            </div>
                        </div>
                        <div className="supplier_dispatch_control_panel">
                            {all_return_dispatches.count > dispatchPageSize && (
                                <Pagination
                                    active={dispatchPage}
                                    pageItemsCount={dispatchPageSize}
                                    pageTotalCount={all_return_dispatches.count}
                                    onChange={(page) => this.changePage('dispatches', page)}
                                />
                            )}
                            <ControlPanel
                                value={dispatchPageSize}
                                onChange={(event) => this.changePageSize('dispatches', event.target.value)}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    };

    renderProducts = () => {
        const { return_dispatch_supplier_products } = this.props.return_dispatches;
        const {
            actionLoading,
            actionType,
            productPage,
            productPageSize,
            productsLoading,
            selectedProductIds,
            stockDialogProduct,
        } = this.state;
        const results = return_dispatch_supplier_products.results || [];

        return (
            <div className="supplier_dispatch_tab_content">
                {this.renderFilters('products')}
                <div className="supplier_products_action_bar">
                    <div className="selected_sum">{formatPrice(this.getSelectedSum())}</div>
                    <DefaultButton
                        disabled={actionLoading || selectedProductIds.length !== 1}
                        onClick={this.openStockDialog}
                    >
                        ОДОБРИТЬ НА СКЛАД
                    </DefaultButton>
                    <DefaultButton
                        variant="contained_green"
                        disabled={actionLoading || selectedProductIds.length === 0}
                        loading={actionLoading && actionType === 'approve'}
                        onClick={this.handleApprove}
                    >
                        ОДОБРИТЬ
                    </DefaultButton>
                </div>
                {productsLoading ? <Loader /> : (
                    <div className="supplier_dispatch_table supplier_products_table">
                        <div className="table_container transactions_columns">
                            <div className="table_header">
                                <div className="table_row">
                                    <div className="row_item">Дата/время</div>
                                    <div className="row_item">Артикул</div>
                                    <div className="row_item">Производитель</div>
                                    <div className="row_item">Наименование</div>
                                    <div className="row_item">Количество</div>
                                    <div className="row_item">Цена</div>
                                    <div className="row_item">Сумма</div>
                                    <div className="row_item">Статус</div>
                                    <div className="row_item" />
                                </div>
                            </div>
                            <div className="table_body">
                                {results.length ? results.map((product) => (
                                    <div className="table_row" key={product.id}>
                                        <div className="row_item">
                                            {moment(product.dispatch_date).format('DD.MM.YYYY HH:mm')}
                                        </div>
                                        <div className="row_item">{product.article_number}</div>
                                        <div className="row_item">{product.producer}</div>
                                        <div className="row_item">{product.name}</div>
                                        <div className="row_item">{product.amount}</div>
                                        <div className="row_item">{formatPrice(product.unit_price)}</div>
                                        <div className="row_item">{formatPrice(product.total_sum)}</div>
                                        <div className="row_item status_cell">
                                            <span className="status_text">
                                                <StatusDot color={getPositionStatusColor(product.item_status)} />
                                                {product.item_status}
                                            </span>
                                            {product.dispatch_id && (
                                                <Link
                                                    to={`/admin/return-dispatch/${product.dispatch_id}`}
                                                    className="related_link_icon"
                                                    title="Открыть выдачу"
                                                >
                                                    <OpenInNewIcon style={{ fontSize: 16 }} />
                                                </Link>
                                            )}
                                        </div>
                                        <div className="row_item checkbox_cell">
                                            {isPendingProduct(product) && (
                                                <Checkbox
                                                    checked={selectedProductIds.includes(product.id)}
                                                    onChange={() => this.toggleProduct(product.id)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                )) : <h1 className="empty_table_message">Товаров не найдено</h1>}
                            </div>
                        </div>
                        <div className="supplier_dispatch_control_panel">
                            {return_dispatch_supplier_products.count > productPageSize && (
                                <Pagination
                                    active={productPage}
                                    pageItemsCount={productPageSize}
                                    pageTotalCount={return_dispatch_supplier_products.count}
                                    onChange={(page) => this.changePage('products', page)}
                                />
                            )}
                            <ControlPanel
                                value={productPageSize}
                                onChange={(event) => this.changePageSize('products', event.target.value)}
                            />
                        </div>
                    </div>
                )}
                <ReturnDispatchOfferToStockDialog
                    open={!!stockDialogProduct}
                    product={stockDialogProduct}
                    loading={actionLoading && actionType === 'stock'}
                    onClose={() => this.setState({ stockDialogProduct: null })}
                    onSubmit={this.handleApproveToStock}
                />
            </div>
        );
    };

    render() {
        const { activeTab, notification, supplierName } = this.state;

        return (
            <TransitionedBlock>
                <div className="return_dispatch_supplier container">
                    <div className="title-block-page">
                        <div className="title-page supplier_title">
                            <BackLink />
                            <h1>Выдачи возвратов — {supplierName || `поставщик #${this.supplierId}`}</h1>
                        </div>
                    </div>
                    <div className="page_block supplier_page_block">
                        <div className="tab_custom supplier_tabs" role="tablist">
                            <button
                                type="button"
                                role="tab"
                                aria-selected={activeTab === 'dispatches'}
                                className={activeTab === 'dispatches' ? 'active' : ''}
                                onClick={() => this.changeTab('dispatches')}
                            >
                                Выдачи
                            </button>
                            <button
                                type="button"
                                role="tab"
                                aria-selected={activeTab === 'products'}
                                className={activeTab === 'products' ? 'active' : ''}
                                onClick={() => this.changeTab('products')}
                            >
                                Товары
                            </button>
                        </div>
                        {activeTab === 'dispatches' ? this.renderDispatches() : this.renderProducts()}
                    </div>
                    <SnackBar
                        open={notification.open}
                        classes={notification.type}
                        vertical="top"
                        onClose={() => this.setState({
                            notification: { ...notification, open: false },
                        })}
                    >
                        {notification.message}
                    </SnackBar>
                </div>
            </TransitionedBlock>
        );
    }
}

const mapStateToProps = ({ return_dispatches }) => ({
    return_dispatches,
});

const mapDispatchToProps = {
    approveReturnDispatch,
    getReturnDispatches,
    getReturnDispatchesDailySummary,
    getReturnDispatchSupplierProducts,
    offerReturnDispatchProductToStock,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReturnDispatchSupplier);
